export default __webpack_public_path__ + "static/media/Autokino_Golden_Hour.a7da8fdf.jpg";